module.exports = __webpack_public_path__ + "static/media/Годишен финансов отчет за 2019.ac40d9c8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Годишен финансов отчет за 2019.pdf
// module id = 116
// module chunks = 0